import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CopyOutlined } from '@ant-design/icons';
import { Col, Form, Tooltip, TreeSelect, message } from 'antd';
import { useEffect, useState } from 'react';
import './FormSelectTree.scss';
import { buildHierarchySelect } from 'src/utils/collection';
import { fullTextSearchFilter } from '../../../utils';
export const FormSelectTree = ({ name, label = '', isRequired = false, readOnly = false, rules = [], hidden = false, isRow = false, className = '', col = 24, responsive = undefined, options, isMultiSelect = false, returnValueType = 'id', value, onChange, popupMatchSelectWidth = 400, isError = false, errorMessage = '', isCopy = false, treeDefaultExpandAll = true, isSelectedObject = false, ...props }) => {
    const [treeValue, setTreeValue] = useState(value);
    const [treeData, setTreeData] = useState([]);
    useEffect(() => {
        if (options && options.length > 0) {
            const hasChildren = options.some((x) => Array.isArray(x.children));
            const data = hasChildren ? options : buildHierarchySelect(options) ?? [];
            setTreeData(data);
        }
        else {
            setTreeData([]);
        }
    }, [options]);
    useEffect(() => {
        setTreeValue(value);
    }, [value]);
    const validationRules = [
        ...(isRequired ? [{ required: true, message: `Trường ${label ?? 'này'} không được để trống!` }] : []),
        ...rules
    ];
    const colProps = responsive ?? { xs: col, sm: col, md: col, lg: col, xl: col, xxl: col };
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        message.success(`Đã copy "${text}"`);
    };
    const renderLabelWithCopy = (text) => (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 6 }, children: [_jsx("span", { style: { flex: 1 }, children: text }), _jsx(Tooltip, { title: 'Sao ch\u00E9p', children: _jsx(CopyOutlined, { onClick: (e) => {
                        e.stopPropagation();
                        handleCopy(text);
                    } }) })] }));
    const customTreeData = treeData?.map((opt) => ({
        ...opt,
        title: isCopy && opt?.title ? renderLabelWithCopy(String(opt?.title)) : opt.title,
        children: opt.children?.map((child) => ({
            ...child,
            title: isCopy && child?.title ? renderLabelWithCopy(String(child?.title)) : child.title
        }))
    }));
    // Tìm node theo value (so sánh bằng string) - hỗ trợ đệ quy
    const findTreeNode = (data, val) => {
        if (!data || val == null)
            return null;
        const strVal = String(val);
        for (const node of data) {
            if (node == null)
                continue;
            if (String(node.value) === strVal || String(node.key) === strVal)
                return node;
            if (node.children) {
                const found = findTreeNode(node.children, val);
                if (found)
                    return found;
            }
        }
        return null;
    };
    // Handler chính cho TreeSelect onChange
    const handleTreeChange = (val, labels, extra) => {
        setTreeValue(val);
        // Nếu user muốn object data được trả về
        if (isSelectedObject) {
            if (isMultiSelect) {
                const values = Array.isArray(val) ? val : val ? [val] : [];
                const selectedObjects = values
                    .map((v) => findTreeNode(treeData, v))
                    .filter((n) => !!n)
                    .map((n) => n.data ?? n);
                onChange?.(val, labels, selectedObjects);
                return;
            }
            const node = findTreeNode(treeData, val);
            onChange?.(val, labels, node?.data ?? undefined);
            return;
        }
        // Nếu muốn return object theo returnValueType === 'object'
        if (returnValueType === 'object') {
            if (isMultiSelect) {
                const values = Array.isArray(val) ? val : val ? [val] : [];
                const selectedObjects = values
                    .map((v) => findTreeNode(treeData, v))
                    .filter((n) => !!n)
                    .map((n) => n.data ?? n);
                onChange?.(selectedObjects, labels, extra);
            }
            else {
                const obj = findTreeNode(treeData, val)?.data ?? extra?.triggerNode?.props?.data;
                onChange?.(obj, labels, extra);
            }
            return;
        }
        // Default: trả về value, labels, extra giống TreeSelect
        onChange?.(val, labels, extra);
    };
    const treeSelectElement = (_jsx(TreeSelect, { ...props, className: `${className || ''} ${readOnly ? 'borderless-select' : ''}`, disabled: readOnly || props.disabled, treeDefaultExpandAll: treeDefaultExpandAll, treeData: customTreeData, value: treeValue, allowClear: true, showSearch: true, multiple: isMultiSelect, placeholder: props.placeholder || `Chọn ${label.toLowerCase()}`, popupMatchSelectWidth: popupMatchSelectWidth, filterTreeNode: fullTextSearchFilter, onChange: handleTreeChange }));
    return (_jsx(Col, { ...colProps, children: _jsxs(Form.Item, { label: isRow ? undefined : label ? _jsx("span", { style: { fontWeight: 600 }, children: label }) : undefined, ...(name ? { name } : {}), rules: validationRules, hidden: hidden, className: className, wrapperCol: !isRow ? { span: 24 } : undefined, style: !isRow ? { padding: 0, marginBottom: 10 } : undefined, children: [isRow && !!label ? (_jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }, children: [_jsxs("label", { style: {
                                minWidth: '20%',
                                fontWeight: 500,
                                marginBottom: 0,
                                whiteSpace: 'nowrap'
                            }, children: [label, isRequired && !!label && _jsx("span", { style: { color: 'red' }, children: " *" })] }), treeSelectElement] })) : (treeSelectElement), isError && errorMessage && (_jsx("div", { className: 'text-danger mt-1', children: _jsx("small", { children: errorMessage }) }))] }) }));
};
export default FormSelectTree;
